/**
 * UTILITAIRE: CONVERSION NOMBRE EN LETTRES (FRANÇAIS)
 * 
 * Convertit un montant en FCFA en lettres
 */

const unite = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
const dizaine = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];
const onze = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];

const numberToWords = (num) => {
  if (num === 0) return 'zéro';
  
  let words = '';
  
  // Millions
  if (num >= 1000000) {
    const millions = Math.floor(num / 1000000);
    if (millions === 1) {
      words += 'un million ';
    } else {
      words += convertLessThanThousand(millions) + ' millions ';
    }
    num %= 1000000;
  }
  
  // Milliers
  if (num >= 1000) {
    const thousands = Math.floor(num / 1000);
    if (thousands === 1) {
      words += 'mille ';
    } else {
      words += convertLessThanThousand(thousands) + ' mille ';
    }
    num %= 1000;
  }
  
  // Centaines
  if (num > 0) {
    words += convertLessThanThousand(num);
  }
  
  return words.trim();
};

const convertLessThanThousand = (num) => {
  let words = '';
  
  // Centaines
  if (num >= 100) {
    const hundreds = Math.floor(num / 100);
    if (hundreds === 1) {
      words += 'cent ';
    } else {
      words += unite[hundreds] + ' cent ';
    }
    num %= 100;
    
    // Accord des centaines
    if (num === 0 && words.endsWith('cent ')) {
      words = words.slice(0, -1) + 's ';
    }
  }
  
  // Dizaines et unités
  if (num >= 20) {
    const tens = Math.floor(num / 10);
    words += dizaine[tens];
    num %= 10;
    
    if (num > 0) {
      if (tens === 7 || tens === 9) {
        // Soixante-dix, quatre-vingt-dix
        words += '-' + onze[num];
        num = 0;
      } else if (num === 1 && tens !== 8) {
        words += ' et un';
        num = 0;
      } else {
        words += '-' + unite[num];
        num = 0;
      }
    } else if (tens === 8) {
      // Quatre-vingts
      words += 's';
    }
  } else if (num >= 10) {
    words += onze[num - 10];
    num = 0;
  }
  
  if (num > 0) {
    words += unite[num];
  }
  
  return words.trim();
};

/**
 * Convertit un montant en FCFA en lettres
 * @param {number} amount - Montant en FCFA
 * @returns {string} - Montant en lettres
 */
export const amountToWords = (amount) => {
  if (!amount || isNaN(amount)) return '';
  
  const intAmount = Math.floor(amount);
  const words = numberToWords(intAmount);
  
  // Capitaliser la première lettre
  const capitalizedWords = words.charAt(0).toUpperCase() + words.slice(1);
  
  return `${capitalizedWords} francs CFA`;
};

export default amountToWords;
